var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.333,
    height: 23,
    viewBox: "0 0 20.333 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notificaciones",
    transform: "translate(-1.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7667",
    "data-name": "Trazado 7667",
    d: "M4.583,7.417a7.417,7.417,0,1,1,14.833,0v.917a18.233,18.233,0,0,0,.754,5.517,4.988,4.988,0,0,0,.711,1.465c.17.216.272.26.3.267a1,1,0,0,1,.989,1v.208a1,1,0,0,1-1,1H2.833a1,1,0,0,1-1-1v-.208a1,1,0,0,1,.989-1c.023-.007.125-.051.3-.267a4.988,4.988,0,0,0,.711-1.465,18.235,18.235,0,0,0,.754-5.517ZM2.818,15.585h0Z",
    fill: "rgba(0,0,0,0.5)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7668",
    "data-name": "Trazado 7668",
    d: "M9.25,19.5a1,1,0,0,0-.8,1.594A4.441,4.441,0,0,0,12,23a4.441,4.441,0,0,0,3.554-1.906,1,1,0,0,0-.8-1.594Z",
    fill: "rgba(0,0,0,0.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.37525c18515fec0237d425b66dec266f.svg";
export { ForwardRef as ReactComponent };